export default __webpack_public_path__ + "static/media/tenancy.64ab4af4.eot";